class BESSAppProjectInlineEditor extends BESSAppBase {

    constructor(profiler) {
        super();
        this.profiler = profiler;
        this.data = this.profiler.data;
        this.itemViews = this.profiler.views.root.find('.app-profiler-item');
        this.inputs = [];
        this.input = {};
        this.needsSave = {
            items: [],
            fields: [],
        }
        this.forEach(this.profiler.data.items, this.setupInlineEditorForItem);
        this.manager = this.#createManager();
    }

    setupInlineEditorForItem(item, itemNo) {
        let itemView = $(this.itemViews[itemNo]);
        itemView.addClass('app-editor-item');
        let fieldViews = itemView.find('.app-profile-field-value');
        this.forEach(this.profiler.data.fields, function (field, fieldNo) {
            let fieldView = $(fieldViews[fieldNo]);
            this.setupInlineEditorForItemField(item, field, fieldView);
        });
    }

    updateState() {
    }

    setupInlineEditorForItemField(item, field, fieldView) {
        let fieldId = uuid4();
        let input = BESSAppProjectEditorInput.for(this, item, field);
        input.editor = this;
        input.required = false;
        let builtInput = input.build();
        let container = fieldView.parent();
        let label = container.parents('tr').find('.items-label');
        let labelContent = label.text();
        label.replaceWith('<label class="items-label" for="' + fieldId + '">' + labelContent + '</label>');
        container.addClass('app-editor-field').addClass('app-editor-field-inline');
        fieldView.addClass(input.containerClass());
        builtInput.addClass('app-value');
        fieldView.empty().append(builtInput);
        fieldView.find('input').attr('id', fieldId);
        fieldView.find('input.first').attr('id', fieldId + '_first');
        fieldView.find('input.second').attr('id', fieldId + '_second');
        fieldView.find('label.first').attr('for', fieldId + '_first');
        fieldView.find('label.second').attr('for', fieldId + '_second');
        fieldView.find('select').attr('id', fieldId);
        input.node = container;
        input.initialise();

        input.onChange(function () {
            if (field.questionIdentifier != null) {
                this.fireEvent(new BESSAppQuestionAnswerDependencyEvent(item, field, input.value, true));
                this.fireEvent(new BESSAppItemQuestionAnswerDependencyEvent(item, field, input.value, true));
            }
            this.#autoSave(item, field);
        }.bind(this));
        this.inputs.push(input);
        this.input[field.variable] = input;
    }

    start() {
        this.forEach(this.inputs, function (input) {
            this.fireEvent(new BESSAppQuestionAnswerDependencyEvent(input.item, input.field, input.value), true);
            this.fireEvent(new BESSAppItemQuestionAnswerDependencyEvent(input.item, input.field, input.value), true);
        }.bind(this));
    }

    inputValueChanged(input) {
        this.#autoSave(input.item, input.field);
    }

    #autoSave(item, field) {
        addUnique(this.needsSave.items, item);
        addUnique(this.needsSave.fields, field);
        this.doDelayed(this.#save, 800);
    }

    #save() {
        if (this.#validate()) {
            let dataForSave = this.profiler.data.toData();
            let itemsForSave = [];
            this.forEach(dataForSave.items, function (itemData, itemIndex) {
                let item = this.profiler.data.items[itemIndex];

                if (isIn(this.needsSave.items, item)) {
                    itemsForSave.push(itemData);

                    let fieldsForSave = [];
                    this.forEach(itemData.fields, function (fieldData, fieldIndex) {
                        let field = this.profiler.data.fields[fieldIndex];
                        if (isIn(this.needsSave.fields, field)) {
                            fieldData.field_no = fieldIndex;
                            fieldsForSave.push(fieldData);
                        }
                    });
                    itemData.fields = fieldsForSave;
                }
            });
            dataForSave.items = itemsForSave;
            this.needsSave.items = [];
            this.needsSave.fields = [];

            BESSApp.instance.services.api.project.editor.apiUpdate(
                dataForSave,
                this.#onSaveFinished.bind(this),
            );
        }
    }

    #validate() {
        let valid = true;
        this.forEach(this.inputs, function (x) {
            if (!x.isHidden()) {
                let invalidReason = x.validate();
                let inputValid = invalidReason == null;
                x.node.find('.app-validation-parent').addClassIf('error', !inputValid);
                x.node.find('.app-error-label').showIf(!inputValid);
                if (!inputValid) {
                    let invalidReasonId = uuid4();
                    x.node.find('.app-error-label').attr('id', invalidReasonId).html(invalidReason);
                    x.markInvalid(invalidReasonId);
                } else {
                    x.markValid();
                }
                valid = inputValid && valid;
            }
        });
        return valid;
    }

    #onSaveFinished(results) {
        this.fireEvent(new BESSAppProjectEditorSavedEvent(results))
    }

    static #editorMap = null;

    #createManager() {

        if (BESSAppProjectInlineEditor.#editorMap == null) {
            BESSAppProjectInlineEditor.#editorMap = {
                'EnergyProfileQuestionsEditor': BESSAppProjectEnergyDetailsEditorManager,
            };
        }

        let managerType = nullIfUndefined(BESSAppProjectInlineEditor.#editorMap[this.data.editorId]);
        if (managerType != null) {
            return new managerType(this);
        }
        return null;
    }
}